module.exports = __webpack_public_path__ + "img/summarize.6b9c2647.svg";